import { DownloadPromptCopy } from "../shared/interfaces/team";

export const DOWNLOAD_PROMPT_DEFAULTS = {
  purchaseHeadline: "TAKE HOME THE MOMENT",
  purchaseBody: "Bring your game-day photo to life with a personalized keepsake.",
  shareHeadline: "SHARE THE MOMENT",
  shareBody: "Know someone else who was at the game? Send them your photo and "
    + "help them find their Momento too.",
  storyHeadline: "TELL US YOUR GAMEDAY STORY",
  storyBody: "Was there something special about today’s game? A first game, birthday, "
    + "family tradition, celebration, unforgettable moment, or anything else? "
    + "We’d love to hear about it.",
};

export function downloadPromptText(
  copy: DownloadPromptCopy | undefined,
  key: keyof typeof DOWNLOAD_PROMPT_DEFAULTS,
): string {
  const value = copy?.[key];
  const fallback = DOWNLOAD_PROMPT_DEFAULTS[key];
  return typeof value === "string" && value.trim() ? value.trim() : fallback;
}
